import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-k8s-secret",
  "use": "oc-res-k8s-secret-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-k8s-secret\"><path fill=\"#333333\" d=\"M512 42.7L128 213.3v256c0 237 163.6 458 384 512 220.4-54 384-275 384-512v-256L512 42.7z m-85.3 682.6L256 554.7l60.4-60.4 110.3 110.3 281-281L768 384 426.7 725.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol